import { render } from "./TableTemplate.vue?vue&type=template&id=5ef523ce&scoped=true"
import script from "./TableTemplate.vue?vue&type=script&lang=js"
export * from "./TableTemplate.vue?vue&type=script&lang=js"

import "./TableTemplate.vue?vue&type=style&index=0&id=5ef523ce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5ef523ce"

export default script